import { render, staticRenderFns } from "./SendClassMsg.vue?vue&type=template&id=6ab45ef5&scoped=true&"
import script from "./SendClassMsg.vue?vue&type=script&lang=js&"
export * from "./SendClassMsg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab45ef5",
  null
  
)

export default component.exports